import React from 'react';

import { BuilderBlocks } from '@builder.io/react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useNavElements } from '~/shared/utils/NavElements';

const StyledHeader = styled.header`
  z-index: 4;
  position: relative;
`;

const BuilderHeaderModelContainer = ({ builderBlock }) => {
  const { headerWrapperRef } = useNavElements();

  return (
    <StyledHeader ref={headerWrapperRef}>
      <BuilderBlocks
        blocks={builderBlock.children}
        parentElementId={builderBlock.id}
      />
    </StyledHeader>
  );
};

BuilderHeaderModelContainer.propTypes = {
  builderBlock: PropTypes.object,
};

export default BuilderHeaderModelContainer;
